/**
 * Pill.tsx
 * Pill — flexible component for displaying information with an icon
 */

import { type FC, ReactNode } from 'react';

import { Icon } from '../icons/Icon';
import { TIconImages } from '../icons/codegen/types';

import styles from './Pill.module.scss';
import { TextBlock } from './TextBlock';
import { TColors } from '../../types';
import cx from 'classnames';

export interface IPillProps {
  children: ReactNode;
  icon?: TIconImages;
  size?: 's' | 'm' | 'l';
  color?: TColors;
  iconColor?: TColors;
}

const SIZE_MAP: Record<'s' | 'm' | 'l', number> = {
  s: 10,
  m: 12,
  l: 16,
};

export const Pill: FC<IPillProps> = ({
  children,
  icon,
  size = 'm',
  color = 'secondaryContrast',
  iconColor = 'text',
}) => {
  const iconSize = SIZE_MAP[size];

  return (
    <div className={styles.pill}>
      <div className={cx(styles.pillIcon, styles['bg-' + color])}>
        {icon && (
          <Icon img={icon} size={iconSize} type="flat" color={iconColor} />
        )}
      </div>
      <div className={cx(styles.pillLine, styles['bg-' + color])}></div>
      <TextBlock size={size} color={color}>
        {children}
      </TextBlock>
    </div>
  );
};
